import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  DateTimeComponent,
  getColumnKey,
  Icon,
  IconComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { BoxQuestionnaireSelectTypeComponent, BoxQuestionnaireStatusComponent } from '@web/shared/module/shop';
import { isNotNil } from '@web/utils';
import { Tooltip } from 'primeng/tooltip';
import { AdminBoxQuestionnaireCollectionFilter } from '../../models/admin-box-questionnaire-collection-filter';
import { AdminBoxQuestionnaireCollectionItem } from '../../models/admin-box-questionnaire-collection-item';

@Component({
  selector: 'app-admin-box-questionnaire-list-custom-cell-template',
  imports: [
    BoxQuestionnaireStatusComponent,
    DateTimeComponent,
    IconComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
    Tooltip,
    BoxQuestionnaireSelectTypeComponent,
  ],
  templateUrl:
    './admin-box-questionnaire-list-custom-cell-template.component.html',
  styleUrl:
    './admin-box-questionnaire-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxQuestionnaireListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBoxQuestionnaireCollectionItem, AdminBoxQuestionnaireCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBoxQuestionnaireCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminBoxQuestionnaireCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Icon = Icon;
}
